<script>
import MottoIcon from '@components/motto-icon.vue'

export default {
  components: {
    MottoIcon,
  },
  props: {
    items: {
      type: Array,
      required: true,
    },
    backRoute: {
      type: String,
      default: '',
    },
    backRouteParams: {
      type: Object,
      default: () => ({}),
    },
  },
}
</script>

<template>
  <div :class="$style.breadcrumbs">
    <div>
      <RouterLink v-if="backRoute" :to="{ name: backRoute, params: backRouteParams }">
        <MottoIcon :class="$style.backButton" name="Arrow" icon-color="gray" class="cursor-pointer" />
      </RouterLink>
    </div>
    <div :class="$style.breadcrumbsItems">
      <template v-for="(item, index) in items">
        <div :key="item.label" style="display: contents">
          <RouterLink v-if="item.routeName" :to="{ name: item.routeName, params: { ...item.routeParams } }">
            <p :class="{ [$style.selectedBreadcrumb]: item.selected }" class="p2 color-darkest-gray">
              {{ item.label.toUpperCase() }}
            </p>
          </RouterLink>
          <p v-else :class="{ [$style.selectedBreadcrumb]: item.selected }" class="p2 color-darkest-gray">
            {{ item.label.toUpperCase() }}
          </p>
          <BaseIcon
            v-if="index < items.length - 1"
            :class="$style.rightArrow"
            class="color-gray"
            name="chevron-right" />
        </div>
      </template>
    </div>
  </div>
</template>

<style lang="scss" module>
@import '@design';

.breadcrumbs {
  display: flex;
  align-items: center;
}

.breadcrumbsItems {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  row-gap: 15px;

  a {
    @media (max-width: $lg-breakpoint) {
      width: min-content;
    }

    display: inline-block;
    text-decoration: none;
    cursor: pointer;
  }
}

.rightArrow {
  margin: 0 13px;
}

.backButton {
  margin-right: 29px;

  > svg {
    width: 30px;
    height: 30px;
  }
}

.selectedBreadcrumb {
  font-size: 14px;
  font-weight: 700;
  color: $primary-blue;

  &::after {
    float: left;
    width: 100%;
    height: 4px;
    content: '';
    background: $primary-blue;
    border-radius: 5px;
  }
}
</style>
